export default "__VITE_ASSET__11175f04__"